import { Component, OnInit } from '@angular/core';
import { getStyle, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities';
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips';
import { Router } from '@angular/router';

@Component({
  templateUrl: 'logout.component.html'
})
export class LogoutComponent implements OnInit {
  constructor(private router: Router) {

  }
  ngOnInit() {
    this.router.navigate(['']);
  }
}
